import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import ReportTabs from './ReportTabs';

class Reports extends Component {
  render() {
    const selfProps = this.props;

    const selectionParams = params => {
      if (params.reportId) {
        params.reportId = parseInt(params.reportId, 10);

        let report = selfProps.reports.find(
          report => report.id === params.reportId
        );

        if (!report) {
          report = selfProps.reports[0];
          params.reportId = report.id;
        }

        if (
          !report.data_provider.versions.find(
            version => version.version === params.reportVersionString
          )
        ) {
          params.reportVersionString = report.data_provider.versions[0].version;
        }

        if (params.reportPageId) {
          params.reportPageId = parseInt(params.reportPageId, 10);
        } else {
          params.reportPageId = report.pages[0].id;
        }

        let reportPage = report.pages.find(
          page => page.id === params.reportPageId
        );

        if (!reportPage) {
          reportPage = report.pages[0];
          params.reportPageId = reportPage.id;
        }

        if (params.reportTabId) {
          params.reportTabId = parseInt(params.reportTabId, 10);
        } else {
          params.reportTabId = reportPage.tabs[0].id;
        }

        let reportTab = reportPage.tabs.find(
          tab => tab.id === params.reportTabId
        );

        if (!reportTab) {
          reportTab = reportPage.tabs[0];
          params.reportTabId = reportTab.id;
        }
      } else {
        params.reportId = selfProps.reports[0].id;
        params.reportVersionString =
          selfProps.reports[0].data_provider.versions[0].version;
        params.reportPageId = selfProps.reports[0].pages[0].id;
        params.reportTabId = selfProps.reports[0].pages[0].tabs[0].id;
      }

      params.isReportVersionLatest =
        params.reportVersionString ===
        selfProps.reports.find(report => report.id === params.reportId)
          .data_provider.current_version;

      return params;
    };

    const redirectWithProps = props => {
      const {
        reportId,
        reportVersionString,
        reportPageId,
        reportTabId
      } = props.match.params;
      const {
        reportId: selectedReportId,
        reportVersionString: selectedReportVersionString,
        isReportVersionLatest: isSelectedReportVersionLatest,
        reportPageId: selectedReportPageId,
        reportTabId: selectedReportTabId
      } = selectionParams({
        reportId,
        reportVersionString,
        reportPageId,
        reportTabId
      });

      this.props.history.replace(
        `/reports/${selectedReportId}/v/${
          isSelectedReportVersionLatest ? 'latest' : selectedReportVersionString
        }/pages/${selectedReportPageId}/tabs/${selectedReportTabId}`
      );

      return (
        <ReportTabs
          versionSwitcher={this.props.versionSwitcher}
          history={this.props.history}
          selectedReportId={selectedReportId}
          selectedReportVersionString={selectedReportVersionString}
          selectedReportPageId={selectedReportPageId}
          selectedReportTabId={selectedReportTabId}
          reports={this.props.reports}
          apiEndpoint={this.props.apiEndpoint}
        />
      );
    };

    return (
      <Switch>
        <Route exact path={`/reports`} render={redirectWithProps} />
        <Route exact path={`/reports/:reportId`} render={redirectWithProps} />
        <Route path={`/reports/:reportId/pages`} render={redirectWithProps} />
        <Route exact path={`/reports/:reportId/v`} render={redirectWithProps} />
        <Route
          exact
          path={`/reports/:reportId/v/:reportVersionString`}
          render={redirectWithProps}
        />
        <Route
          exact
          path={`/reports/:reportId/v/:reportVersionString/pages`}
          render={redirectWithProps}
        />
        <Route
          exact
          path={`/reports/:reportId/v/:reportVersionString/pages/:reportPageId`}
          render={redirectWithProps}
        />
        <Route
          exact
          path={`/reports/:reportId/v/:reportVersionString/pages/:reportPageId/tabs`}
          render={redirectWithProps}
        />
        <Route
          exact
          path={`/reports/:reportId/v/:reportVersionString/pages/:reportPageId/tabs/:reportTabId`}
          render={props => {
            const {
              reportId,
              reportVersionString,
              reportPageId,
              reportTabId
            } = props.match.params;
            const {
              reportId: selectedReportId,
              reportVersionString: selectedReportVersionString,
              isReportVersionLatest: isSelectedReportVersionLatest,
              reportPageId: selectedReportPageId,
              reportTabId: selectedReportTabId
            } = selectionParams({
              reportId,
              reportVersionString,
              reportPageId,
              reportTabId
            });
            if (
              parseInt(reportId, 10) === selectedReportId &&
              (isSelectedReportVersionLatest
                ? reportVersionString === 'latest'
                : reportVersionString === selectedReportVersionString) &&
              parseInt(reportPageId, 10) === selectedReportPageId &&
              parseInt(reportTabId, 10) === selectedReportTabId
            ) {
              return (
                <ReportTabs
                  versionSwitcher={this.props.versionSwitcher}
                  history={this.props.history}
                  selectedReportId={selectedReportId}
                  selectedReportVersionString={selectedReportVersionString}
                  selectedReportPageId={selectedReportPageId}
                  selectedReportTabId={selectedReportTabId}
                  reports={selfProps.reports}
                  apiEndpoint={selfProps.apiEndpoint}
                />
              );
            } else {
              return redirectWithProps(props);
            }
          }}
        />
      </Switch>
    );
  }
}

export default Reports;
